/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../bbrisk/action';
import '../component/component';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "challenge": {
                "nested": {
                  "StartChallengeRequest": {
                    "fields": {
                      "actionType": {
                        "type": ".squareup.bbrisk.action.ActionType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "phoneNumber": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "countryCode": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "webUrl": {
                        "type": ".squareup.bbfrontend.common.component.WebURL",
                        "id": 5,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 1
                      }
                    },
                    "nested": {
                      "account_identifier": {
                        "oneof": ["unitToken"]
                      }
                    }
                  },
                  "StartChallengeResponse": {
                    "fields": {}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.challenge?.nested?.StartChallengeRequest && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.challenge?.nested?.StartChallengeResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE StartChallengeRequest @ squareup/bbfrontend/common/challenge/start_challenge.proto at 14:1
 */
export const StartChallengeRequest = $root.lookupType('squareup.bbfrontend.common.challenge.StartChallengeRequest');
fixType(StartChallengeRequest, {
  actionType: {
    required: true
  },
  phoneNumber: {
    notEmpty: true
  },
  countryCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(StartChallengeRequest);
/**
 * SOURCE StartChallengeResponse @ squareup/bbfrontend/common/challenge/start_challenge.proto at 27:1
 */
export const StartChallengeResponse = $root.lookupType('squareup.bbfrontend.common.challenge.StartChallengeResponse');
fixType(StartChallengeResponse);
Builder.createAndAttachToType(StartChallengeResponse);